import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import DataGridTamplet from "../Helper/TableTemplet/DataGridTamplet";
import { activeAccount, changeDefaultAccount, deleteAccount, getAccountList } from "./AccountUtil";
import "./Account.scss";
import { Box, Button, MenuItem, TextField } from "@mui/material";
import FirstMonthSummaryDialog from "../Dialogs/FirstMonthSummaryDialog";

const Account = () => {
  const dispatch = useDispatch();
  const account = useSelector((state: any) => state.account.accounts_list);
  const accounts = useSelector((state: any) => state.account.account_list);
  const navigate = useNavigate();
  const [filtersValues, setFiltersValues] = useState({ fieldText: "" });
  const [openFirstMonthSummaryDialog, setOpenFirstMonthSummaryDialog] = useState(false);
  const [accountId, setAccountId] = useState(null);
  const [searchField, setSearchField] = useState("account_name");

  const loginAsAccount = (account_id) => {
    let account = accounts.find((item) => item.id === account_id);
    changeDefaultAccount(dispatch, account);
    navigate("/layout");
  };

  const columns: GridColDef[] = [
    {
      field: "account_name",
      headerName: "Account Name",
      sortable: true,
      width: 150
    },
    { field: "email", headerName: "Email", sortable: true, width: 200 },
    { field: "phone", headerName: "Phone", sortable: true, width: 100 },
    {
      field: "email_from_refund",
      headerName: "Refund Email",
      sortable: true,
      width: 140,
    },
    {
      field: "analyst_name",
      headerName: "Analyst Name",
      sortable: true,
      width: 140
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 160,
      sortable: false,
      renderCell: (params: GridRenderCellParams) => (
        <Box sx={{ transform: "scale(0.9)" }}>
          <Button
            variant="outlined"
            className="blue-outlined-btn mr-10p"
            tabIndex={params.hasFocus ? 0 : -1}
            onClick={() => navigateUserForm(params.id as number)}
          >
            Edit
          </Button>
          <Button
            variant="outlined"
            disabled={params.row.status !== "Y"}
            tabIndex={params.hasFocus ? 0 : -1}
            className={`red-outlined-btn ${params.row.status === "N" ? 'd-none' : ''}`}
            onClick={() => deleteAccount(dispatch, params.row.id as number)}
          >
            Delete
          </Button>
          <Button
            variant="outlined"
            disabled={params.row.status !== "N"}
            tabIndex={params.hasFocus ? 0 : -1}
            className={`green-outlined-btn ${params.row.status === "Y" ? 'd-none' : ''}`}
            onClick={() => activeAccount(dispatch, params.row.id as number)}
          >
            Active
          </Button>
        </Box>
      ),
    },
    {
      field: "first_month_summary",
      headerName: "First Month Summary",
      width: 165,
      sortable: false,
      renderCell: (params: GridRenderCellParams) => (
        <>
          <Button
            variant="outlined"
            tabIndex={params.hasFocus ? 0 : -1}
            className={'blue-outlined-btn'}
            onClick={() => { setAccountId(params.row.id as number); setOpenFirstMonthSummaryDialog(true); }}
          >
            Show
          </Button>
        </>
      ),
    },
    {
      field: "log_in",
      headerName: "Log in",
      width: 155,
      sortable: false,
      renderCell: (params: GridRenderCellParams) => (
        <>
          {params.row.status === "Y" && (
            <Box sx={{ transform: "scale(0.9)" }}>
              <Button
                onClick={() => loginAsAccount(params.row.id)}
                className="blue-color"
              >
                Log In as an Account
              </Button>
            </Box>
          )}
        </>
      ),
    },
  ];

  useEffect(() => {
    getAccountList(dispatch);
  }, []);

  const navigateUserForm = (userId: number) => {
    navigate(`/layout/administrator/account/details/${userId}`);
  };

  const search = (list, inputValue) => {
    return automaticSearch(list, inputValue);
  };

  const automaticSearch = (list, value) => {
    if (value === "") return list;

    return list.filter((item) => {
      const fieldValue = item[searchField];
      return fieldValue !== null && fieldValue.toString().toLowerCase().includes(value.toLowerCase());
    });
  };

  return (
    <div>
      <h2>Accounts</h2>
      <Box display="flex" alignItems="center" mb={2}>
        <TextField
          select
          value={searchField}
          onChange={(e) => setSearchField(e.target.value)}
          label="Search Field"
          variant="outlined"
          sx={{ marginRight: 2 }}
        >
          <MenuItem value="account_name">Account Name</MenuItem>
          <MenuItem value="email">Email</MenuItem>
          <MenuItem value="phone">Phone</MenuItem>
          <MenuItem value="email_from_refund">Refund Email</MenuItem>
          <MenuItem value="analyst_name">Analyst Name</MenuItem>
        </TextField>
        <TextField
          variant="outlined"
          label={`Search by ${searchField.replace('_', ' ')}`}
          value={filtersValues.fieldText}
          onChange={(e) => setFiltersValues({ ...filtersValues, fieldText: e.target.value })}
        />
      </Box>
      <DataGridTamplet
        columns={columns}
        rows={search(account, filtersValues.fieldText)}
      />
      <FirstMonthSummaryDialog
        open={openFirstMonthSummaryDialog}
        setOpen={setOpenFirstMonthSummaryDialog}
        accountId={accountId}
        setAccountId={setAccountId}
      />
    </div>
  );
};

export default Account;